// extracted by mini-css-extract-plugin
export default {"mainbox":"lb_mainbox__00V5r","root":"lb_root__4+-U-","app":"lb_app__NV2HI","content":"lb_content__WwuwG"};